import axios from "axios";
import React from "react";
import { useState, useEffect } from "react";
import { Container, Form } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Offcanvas from "react-bootstrap/Offcanvas";
import { imageDb } from "../firebase";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import emailjs from "@emailjs/browser";
import imageCompression from "browser-image-compression";

export default function Pembayaran2({
  tgl,
  harga,
  namateam,
  idlapangan,
  lapangan,
  jambooking,
  jambooking2,
  totalharga,
  sistempembayaran,
  wa,
  wasit,
  video,
  foto,
  rompi,
  bola,
  item,
  showpay,
}) {

  const upload_preset = process.env.REACT_APP_UPLOAD_PRESET;
  const cloud_name = process.env.REACT_APP_CLOUD_NAME;
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const urlapi = process.env.REACT_APP_BASE_URL;
  const [norek, setNorek] = useState("");
  const [atasnama, setAtasnam] = useState("");
  const [nameImg, setNameImg] = useState("");
  const [valueimg, setvalueimg] = useState("");
  const [img, setImg] = useState("");
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState(true);
  const [alertwa, setAlertwa] = useState(false);
  const [datajson, setDatajson] = useState([]);
  const [image, setImage] = useState(null);
  const [loadingUpload, setLoadingUpload] = useState('');

  useEffect(() => {
    if (showpay) {
      setShow(true);
    }
  }, [showpay]);



  const handleChangeImg = async (e) => {
    const file = e.target.files[0];
    setImg(e.target.files[0]);
    // console.log(e);
    setvalueimg(e.target.value);
    setNameImg(e.target.files[0].name);
    const options = {
      maxSizeMB: 1, // Maksimum ukuran gambar dalam MB
      maxWidthOrHeight: 800, // Dimensi maksimum
      useWebWorker: true,
    };

    try {
      const compressedFile = await imageCompression(file, options);
      // Pratinjau gambar
      // setPreview(URL.createObjectURL(compressedFile));
      setImage(compressedFile); // Simpan gambar yang sudah dikompres
      setLoadingUpload('berhasil')
      console.log(compressedFile);

    } catch (error) {
      console.error("Gagal mengompres gambar:", error);
    }

  };

  const handleBooking = async () => {
    setLoading(true);
    setForm(false);

    if (!image) return
    const data = new FormData();
    data.append('file', image);
    data.append('upload_preset', upload_preset);
    data.append('cloud_name', cloud_name);

    const res = await fetch(`https://api.cloudinary.com/v1_1/${cloud_name}/image/upload`, {
      method: "POST",
      body: data
    })
    const uploadedImageUrl = await res.json()
    console.log(uploadedImageUrl.url);
    // setUrlimg(uploadedImageUrl.url)
    addbooking(uploadedImageUrl.url);
  };

  const addbooking = async (url) => {

    const storedItems = JSON.parse(localStorage.getItem("selectedItems"));
    await axios
      .post(urlapi + "Addbookingbaru2", {
        nama: localStorage.getItem("nama"),
        iduser: localStorage.getItem("id"),
        id_lapangan: idlapangan,
        lapangan: lapangan,
        tgl: tgl,
        harga: harga,
        team: namateam,
        jam: jambooking,
        jam2: jambooking2,
        bukti: url,
        norek: norek,
        atasnama: atasnama,
        sistempembayaran: sistempembayaran,
        totalharga: totalharga,
        wa: wa,
        wasit: wasit,
        video: video,
        foto: foto,
        rompi: rompi,
        bola: bola,
        img: valueimg,
        item: storedItems
      })

      .then((response) => {
        console.log(response.data);
        sendwa(response.data.kode_booking);
        resetrankteam();
        // jika berhasil bookign maka localStorage selectedItem di hapus
        localStorage.removeItem('selectedItems');

      })
      .catch((error) => {
        // console.log(error.message);
        setAlertwa(true);
        setLoading(false);
      });
  };




  const sendwa = async (kodebooking) => {
    try {
      const response = await axios.get(
        urlapi +
        "Sendwa?jam=" +
        jambooking +
        "&tgl=" +
        tgl +
        "&kodebooking=" +
        kodebooking
      );
      console.log(response.data);
      setLoading(false);
      if (response.data.status == false) {
        setAlertwa(false);
      } else {
        setAlertwa(false);
      }
    } catch (error) {
      console.log(console.error("message"));
    }
  };

  const resetrankteam = async () => {
    try {
      const response = await axios.get(
        urlapi +
        "Addbooking?tgl=" +
        tgl +
        "&&idlap=" +
        idlapangan +
        "&&jam=" +
        jambooking
      );
      // console.log(response.data);
    } catch (error) {
      // console.log(error.message);
    }
  };

  const handlebtnpopup = () => {
    setForm(true);
    setShow(false);
  };

  return (
    <>

      <Offcanvas
        show={show}
        onHide={handleClose}
        placement="bottom"
        className="payment-booking-offcanvas"
        style={{ height: "85vh", borderRadius: "16px 16px 0 0" }}
      >
        <Offcanvas.Header
          closeButton
          style={{
            backgroundColor: "#2b2e5a",
            color: "#fff",
            borderBottom: "none",
          }}
        >
          <Container>
            <Offcanvas.Title
              style={{ fontWeight: "bold", fontSize: "1.05rem" }}
            >
              <i className="fas fa-credit-card me-2"></i>
              Pembayaran Booking
            </Offcanvas.Title>
            <div style={{ fontSize: "0.75rem", color: "#b8bcc9" }}>
              Lengkapi data pembayaran anda di bawah ini
            </div>
          </Container>
        </Offcanvas.Header>
        <Offcanvas.Body style={{ backgroundColor: "#f8f9fa" }}>
          <Container>
            {loading ? (
              <div className="text-center" style={{ marginTop: "150px" }}>
                <div class="spinner-grow text-primary" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
                <div class="spinner-grow text-secondary" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
                <div class="spinner-grow text-success" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
                <br></br>
                <label>Loading....</label>
                <p className="text-center">
                  Mohon untuk menunggu proses pembayaran
                </p>
              </div>
            ) : (
              <div>
                {form ? (
                  <>
                    <div
                      className="card border-0 shadow-sm mb-3"
                      style={{ borderRadius: "12px" }}
                    >
                      <div className="card-body d-flex justify-content-between align-items-center">
                        <div>
                          <div
                            className="fw-bold"
                            style={{ color: "#2b2e5a", fontSize: "0.85rem" }}
                          >
                            Total Pembayaran
                          </div>
                          <div
                            className="text-secondary"
                            style={{ fontSize: "0.7rem" }}
                          >
                            {sistempembayaran == "Dp"
                              ? "DP 50% dari total"
                              : "Pembayaran Lunas"}
                          </div>
                        </div>
                        <div
                          className="fw-bold"
                          style={{ color: "#28a745", fontSize: "1.1rem" }}
                        >
                          {(sistempembayaran == "Dp" ? totalharga / 2 : totalharga)
                            .toLocaleString("id-ID")}
                        </div>
                      </div>
                    </div>

                    <Form.Group className="mb-3" controlId="formBasicEmail">
                      <Form.Label
                        className="checkout-label"
                      >
                        <i className="fas fa-university me-1"></i>
                        Nama Bank Anda
                      </Form.Label>
                      <div className="checkout-input-wrapper">
                        <select
                          className="checkout-input"
                          required
                          onChange={(e) => setNorek(e.target.value)}
                        >
                          <option value="">-- Pilih Nama Bank Anda --</option>
                          <option>BRI</option>
                          <option>BNI</option>
                          <option>BCA</option>
                          <option>Mandiri</option>
                          <option>Bank Sumut</option>
                          <option>Danamon</option>
                          <option>CIMB Niaga</option>
                          <option>Lainya</option>
                        </select>
                      </div>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formBasicEmail">
                      <Form.Label
                        className="checkout-label"
                      >
                        <i className="fas fa-user me-1"></i>
                        Atas Nama
                      </Form.Label>
                      <div className="checkout-input-wrapper">
                        <Form.Control
                          type="text"
                          className="checkout-input"
                          onChange={(e) => setAtasnam(e.target.value)}
                          placeholder="Masukan nama pemilik rekening"
                        />
                      </div>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formBasicupload">
                      <Form.Label
                        className="checkout-label"
                      >
                        <i className="fas fa-file-image me-1"></i>
                        Bukti Pembayaran
                      </Form.Label>
                      <label
                        for="images"
                        class="drop-container"
                        id="dropcontainer"
                        style={{
                          border: "2px dashed #2b2e5a",
                          borderRadius: "12px",
                          backgroundColor: "#fff",
                        }}
                      >
                        <span class="drop-title">
                          {nameImg == "" ? (
                            <>
                              <i
                                className="fas fa-cloud-upload-alt"
                                style={{ fontSize: "1.6rem", color: "#2b2e5a" }}
                              ></i>
                              <span
                                className="d-block mt-1 fw-bold"
                                style={{ color: "#2b2e5a" }}
                              >
                                Upload bukti pembayaran
                              </span>
                            </>
                          ) : loadingUpload == 'load' ? <> <div class="spinner-border" role="status">
                            <span class="visually-hidden">Loading...</span>
                          </div> Loading .....</> : loadingUpload == 'berhasil' ? <>
                            <i class="fa-solid fa-circle-check text-success"></i>{" "}
                            Upload sukses
                          </>
                            : <></>

                          }
                        </span>

                        <input
                          type="file"
                          id="images"
                          className="form-control"
                          accept="image/*"
                          onChange={(e) => handleChangeImg(e)}
                          required
                        />
                      </label>
                      <Form.Text
                        className="d-block mt-1"
                        style={{ color: "#6c757d", fontSize: "0.7rem" }}
                      >
                        <i className="fas fa-info-circle me-1"></i>
                        Upload bukti pembayaran dengan format Gambar (JPG, JPEG
                        & PNG)
                      </Form.Text>
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="formBasicEmail">
                      <Form.Label
                        className="checkout-label"
                      >
                        Keterangan
                      </Form.Label>
                      <div className="checkout-input-wrapper">
                        <textarea
                          className="checkout-input"
                          placeholder="Tulis keterangan (opsional)"
                          rows="2"
                        ></textarea>
                      </div>
                    </Form.Group>

                    {valueimg == "" || atasnama == "" || norek == "" || loadingUpload == '' || loadingUpload == 'load' ? (
                      <button
                        className="btn w-100 rounded-pill disabled"
                        style={{ backgroundColor: "#2b2e5a", color: "white" }}
                      >
                        <i className="fas fa-lock me-1"></i>
                        Bayar sekarang
                      </button>
                    ) : (
                      <button
                        className="btn w-100 rounded-pill"
                        onClick={() => handleBooking()}
                        style={{ backgroundColor: "#2b2e5a", color: "white" }}
                      >
                        <i className="fas fa-check-circle me-1"></i>
                        Bayar sekarang
                      </button>
                    )}
                  </>
                ) : (
                  <div className="text-center" style={{ paddingTop: "40px" }}>
                    {alertwa ? (
                      <div>
                        <img
                          src="/close.png"
                          className="img-fluid"
                          alt=""
                          style={{ height: "90px" }}
                        ></img>
                        <h5 className="mt-4 text-secondary" style={{ fontSize: "1rem" }}>
                          <strong>
                            Hei, {localStorage.getItem("nama")}{" "}
                          </strong>
                          <br></br>
                          <span style={{ fontSize: "0.85rem" }}>
                            Pembayaran anda gagal, pastikan bukti pembayaran
                            terisi dengan benar mohon untuk mencoba lagi
                          </span>
                        </h5>
                        <a
                          href={"/formbooking/" + idlapangan}
                          className="btn rounded-pill px-5"
                          style={{
                            backgroundColor: "#2b2e5a",
                            color: "white",
                          }}
                        >
                          Coba lagi
                        </a>
                      </div>
                    ) : (
                      <>
                        <img
                          src="/sukses.png"
                          className="img-fluid"
                          alt=""
                          style={{ height: "90px" }}
                        ></img>
                        <h5 className="mt-4 text-secondary" style={{ fontSize: "1rem" }}>
                          <strong>
                            Hei, {localStorage.getItem("nama")}{" "}
                          </strong>
                          <br></br>
                          <span style={{ fontSize: "0.85rem" }}>
                            Pembayaran anda berhasil dikirim silahkan menunggu
                            persetujuan pembayaran anda
                          </span>
                        </h5>
                        <a
                          href={"/formbooking/" + idlapangan}
                          className="btn rounded-pill px-5"
                          style={{
                            backgroundColor: "#2b2e5a",
                            color: "white",
                          }}
                        >
                          Tutup popup
                        </a>
                      </>
                    )}
                  </div>
                )}
              </div>
            )}
          </Container>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}
